export default __webpack_public_path__ + "static/media/鉴定师勋章@2x.bbacf94e.png";